import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import Model from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Select from 'antd/lib/select';
import React, { useEffect, useState, useContext } from 'react';
import { axiosGetCall, axiosPostCall } from '../api/axiosCall';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';

function PriceCategoryModal({
  isOpen,
  companyId,
  callback,
  handlePriceListModelCloseClick,
}) {
  const [priceCategoryList, setPriceCategoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [selectedPriceCategory, setSelectedPriceCategory] = useState([]);

  useEffect(() => {
    getPriceCategoryList();
  }, []);

  async function getPriceCategoryList() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_PRODUCT_PRICE_CATEGORY,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setPriceCategoryList(res.data);
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      console.error(error);
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  async function assignPriceListToCompany() {
    try {
      if (
        selectedPriceCategory.includes(1) ||
        selectedPriceCategory.includes(2) ||
        selectedPriceCategory.includes(3)
      ) {
        if (
          selectedPriceCategory.length !== 1 &&
          !selectedPriceCategory.includes(4)
        ) {
          message.error(
            'You can not assign more than one distributer price list',
          );
          return;
        } else if (selectedPriceCategory.length > 2) {
          message.error('You can not assign more than two price list');
          return;
        }
      }
      setIsLoading(true);
      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.ADD_PRODUCT_PRICE_CATEGORY,
        header: {
          Authorization: `Bearer ${token}`,
        },
        body: {
          companyId: companyId,
          productPriceCategories: selectedPriceCategory,
        },
      });
      if (res?.hideErrorFromUser) {
        message.success('Price List Assign to company successfully');
        callback();
        setSelectedPriceCategory([]);
        return;
      } else {
        message.error(res?.error?.message);
      }
    } catch (error) {
      console.error(error);
      message.error(SOMETHING_WENT_WRONG);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handlePriceListModelCloseClick}
        closable={false}
        footer={null}
      >
        <div className='flex flex-col space-y-4'>
          <Row className='font-bold text-2xl self-center'>Price List</Row>
          <Select
            placeholder='Select a Price List'
            showSearch
            mode='multiple'
            onChange={(value) => {
              setSelectedPriceCategory(value);
            }}
            value={selectedPriceCategory}
          >
            {priceCategoryList.map((priceCategory) => (
              <Option
                key={priceCategory.priceCategoryId}
                value={priceCategory.priceCategoryId}
              >
                {priceCategory.priceCategoryDescription}
              </Option>
            ))}
          </Select>
          <div className='flex flex-row justify-around'>
            <Button
              onClick={assignPriceListToCompany}
              className='w-32 self-center'
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default PriceCategoryModal;
